export function getPreferredColorScheme() {
  const { matchMedia } = window;
  if (!matchMedia) return;

  return matchMedia("(prefers-color-scheme: dark)").matches;
}
